import React, { useState } from "react";
import { BsPencil } from "react-icons/bs";
import { VscVerified } from "react-icons/vsc";
import profileImage from "../../assets/img/profileImg.png";
import nigeriaFlag from '../../assets/img/flag/nigeria-flag.png'
import { MdOutlineContentCopy } from "react-icons/md";
import { Share2 } from "lucide-react";
import { toast } from "react-toastify";


const ProfileCard = ({ userDetails }) => {
  const showKyc = userDetails?.has_approved_kyc;
  const userCountryCode = userDetails?.country_code;
  const [copied, setCopied] = useState(false);
  const referralCode = userDetails?.referral_code?.code;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const referralLink = referralCode ? `${baseUrl}/getstarted?ref=${referralCode}` : `${baseUrl}/getstarted`; 
  const handleCopyLink = () => {
      navigator.clipboard.writeText(referralLink);
      setCopied(true);

      setTimeout(() => {
          setCopied(false);
      }, 5000);
  };

  const [flagUrl, setFlagUrl] = useState(getFlagUrl(userCountryCode));        

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { month: "long", year: "numeric" };
    return `Since ${date.toLocaleString("en-US", options)}`;
  };

  return (
    <section className="profile-card">
      {/* Header Section */}
      <div className="profile-header">
        <div className="profile-image pb-3">
            <img src={userDetails?.avatar || profileImage} alt="img" className="img-fluid" />
        </div>
        <div className="profile-info d-flex flex-column align-items-start">
        {userDetails?.username ? (
              <span className="username">@{userDetails?.username}</span>
          ) : (
              <button 
                  className="btn btn-link p-0 add__username__btn" 
                  data-bs-toggle="modal" 
                  data-bs-target="#addUsernameModal"
              >
                  Click to add username
              </button>
          )}
          <h4 className="name">{userDetails?.full_name}</h4>
        </div>
        <BsPencil className="edit-icon" />
      </div>


      {/* Body Section */}
      <div className="profile-body text-center">
        <div className="verified-showcase mb-4">
          {showKyc ? (
            <div className="verified-tag d-flex align-items-center justify-content-center gap-2">
              <h4 className="mb-0">Account Verified</h4>
              <VscVerified size={30} />
            </div>
          ) : (
            <div className="verified-warning">
              <div className="text-warning d-flex align-items-center justify-content-center gap-2">
                <h4 className="mb-0">Account Unverified</h4>
                <VscVerified size={30} />
              </div>
              {userDetails?.account_type == 'personal' && <button className="btn btn-link p-0 add__username__btn"
                data-bs-toggle="modal" 
                data-bs-target="#kycModal"
              >
                  Click to verify your account
              </button>}
            </div>
          )}
        </div>
        <div className="d-flex flex-column mb-4">
            <p className="location mb-0">
                <img src={flagUrl} alt="Location" className="icon" />
                {userDetails?.city}, {userDetails?.country}
            </p>
            <p className="account-type mb-0">{userDetails?.account_type} ACCOUNT</p>
            {/* <h6 className='text-muted'><small>Account Number: {userDetails?.bank_account[0]?.account_number}</small></h6> */}
            <p className="since mb-0">{formatDate(userDetails?.created_at)}</p>
        </div>

        <div className="d-flex flex-column gap-1 mb-5">
            <h4 className="full-name mb-0">{userDetails?.full_name}</h4>
            <p className="phone-number mb-0">{userDetails?.phone}</p>
        </div>

        <div className="stats">
          <div className="stat">
            <h5>{userDetails?.referral_count ?? 0}</h5>
            <p>Referrals</p>
          </div>
        </div>

        <div className="mt-4 d-flex align-items-center justify-content-center flex-wrap gap-3">
          <button
              className="btn btn-info btn-sm share-btn" style={{ backgroundColor: "#0A95FF", }}
              onClick={() => {
                  if (navigator.share) {
                    navigator.share({
                    title: 'Join me on CardPlot!',
                    text: 'Use my referral link to get started:',
                    url: referralLink,
                  }).catch((err) => {
                      // console.error('Error sharing:', err);
                  });
                  } else {
                    handleCopyLink();
                    toast.warning('Sharing is not supported on this browser. Link copied to clipboard instead!');
                  }
              }}
              title="Share Your Referral Link"
              >
              <Share2 size={18} className="me-2" />
              Share Your Referral link
          </button>
          <div className="d-flex align-items-center gap-2">
              {/* <span className="mb-0">Copy</span> */}
              <div className="position-relative">
                  <div className="copy-icon" title='Copy Referral Link'>
                      <div className="position-relative">
                          <MdOutlineContentCopy role="button" size={20} color="#0A95FF" onClick={handleCopyLink} />
                          {/* Tooltip */}
                          {copied && (
                              <div className="copy-tooltip text-white p-2 rounded small">
                                  Copied!
                              </div>
                          )}
                      </div>
                  </div>
              </div>
          </div>
          <h6>Your referral code: <span className="text-primary">{referralCode}</span></h6>
        </div>

      </div>
    </section>
  );
};

export const getFlagUrl = (countryCode) => {
    if (!countryCode) return "ng"; 
    return `https://flagcdn.com/144x108/${countryCode.toLowerCase()}.png`;  
  };

export default ProfileCard;
